var _use, _use2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRcLoadingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 199 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#rc_loading_icon_svg__cloud",
    className: "rc_loading_icon_svg__cloud-path",
    stroke: "url(#rc_loading_icon_svg__paint1_linear)",
    strokeWidth: 10,
    clipPath: "url(#rc_loading_icon_svg__cloud-clip)",
    filter: "url(#rc_loading_icon_svg__f1)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#rc_loading_icon_svg__book",
    className: "rc_loading_icon_svg__book-path",
    stroke: "url(#rc_loading_icon_svg__paint0_linear)",
    strokeWidth: 10,
    clipPath: "url(#rc_loading_icon_svg__book-clip)",
    filter: "url(#rc_loading_icon_svg__f1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "rc_loading_icon_svg__cloud",
    stroke: "url(#rc_loading_icon_svg__paint1_linear)",
    d: "M51.545 30.249c-.924 1.235-1.54 2.778-2.157 4.012-.308.31-.308.618-.616.926-.616 1.235-1.232 2.779-1.848 4.013-.308.309-.308.926-.616 1.235 0 .308-.308.617-.308.926 3.08-4.013 13.554-15.433 27.415-15.433 5.545 0 10.782 1.852 16.018 5.247 5.853.926 10.473 4.63 12.63 10.186l.308.926V96.92c0 8.951-5.853 10.186-5.853 10.186l-27.723 9.568h97.032c18.174 0 32.652-14.815 32.652-32.718 0-9.877-4.313-18.52-11.09-24.384-.616-.617-1.54-1.235-2.156-1.852v0c-.616-.617-1.54-.926-2.156-1.544 0 0-.308 0-.308-.308-.616-.309-1.541-.926-2.157-1.235-.308 0-.308-.308-.616-.308-.616-.31-1.232-.618-2.156-.926-.308 0-.616-.31-.924-.31-.616-.308-1.232-.308-1.848-.616-.308 0-.924-.31-1.232-.31-.617 0-1.233-.308-1.541-.308-.616 0-1.232-.308-1.848-.308-.308 0-.924 0-1.232-.31-.924 0-2.156-.308-3.08-.308h-.925c-.308-1.852-.616-3.704-1.232-5.556 0-.308-.308-.926-.308-1.234-.308-1.235-.924-2.778-1.232-4.013 0-.309-.308-.926-.616-1.235-.616-1.234-1.232-2.777-1.848-4.012 0-.309-.308-.617-.616-.926-.616-1.235-1.54-2.778-2.156-4.013C146.42 12.038 126.706 0 104.219 0 82.04.309 62.326 12.347 51.545 30.249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rc_loading_icon_svg__book",
    stroke: "url(#rc_loading_icon_svg__paint0_linear)",
    d: "M51.01 46.17l.308 58.82c7.729-15.479 29.06-13.002 29.06-13.002 7.11.928 8.038-3.406 8.038-3.406v-44.58c2.164-3.095 4.637 0 4.637 0l-.309 52.939-39.88 15.479H6.183c-2.473-1.548-.31-3.715-.31-3.715h32.77c5.256 0 4.947-5.263 4.947-5.263v-52.32H6.8c-6.183 0-6.183 4.954-6.183 4.954v54.796c0 5.882 5.874 5.882 5.874 5.882h46.063l42.044-14.55c2.473-1.858 2.782-5.263 2.782-5.263V43.693c-2.164-5.573-6.801-6.501-9.274-6.501-4.947-3.715-9.584-5.263-13.912-5.263-13.293 0-23.186 14.24-23.186 14.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rc_loading_icon_svg__cloud-shadow",
    stroke: "#000",
    d: "M51.545 30.249c-.924 1.235-1.54 2.778-2.157 4.012-.308.31-.308.618-.616.926-.616 1.235-1.232 2.779-1.848 4.013-.308.309-.308.926-.616 1.235 0 .308-.308.617-.308.926 3.08-4.013 13.554-15.433 27.415-15.433 5.545 0 10.782 1.852 16.018 5.247 5.853.926 10.473 4.63 12.63 10.186l.308.926V96.92c0 8.951-5.853 10.186-5.853 10.186l-27.723 9.568h97.032c18.174 0 32.652-14.815 32.652-32.718 0-9.877-4.313-18.52-11.09-24.384-.616-.617-1.54-1.235-2.156-1.852v0c-.616-.617-1.54-.926-2.156-1.544 0 0-.308 0-.308-.308-.616-.309-1.541-.926-2.157-1.235-.308 0-.308-.308-.616-.308-.616-.31-1.232-.618-2.156-.926-.308 0-.616-.31-.924-.31-.616-.308-1.232-.308-1.848-.616-.308 0-.924-.31-1.232-.31-.617 0-1.233-.308-1.541-.308-.616 0-1.232-.308-1.848-.308-.308 0-.924 0-1.232-.31-.924 0-2.156-.308-3.08-.308h-.925c-.308-1.852-.616-3.704-1.232-5.556 0-.308-.308-.926-.308-1.234-.308-1.235-.924-2.778-1.232-4.013 0-.309-.308-.926-.616-1.235-.616-1.234-1.232-2.777-1.848-4.012 0-.309-.308-.617-.616-.926-.616-1.235-1.54-2.778-2.156-4.013C146.42 12.038 126.706 0 104.219 0 82.04.309 62.326 12.347 51.545 30.249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rc_loading_icon_svg__book-shadow",
    stroke: "#000",
    d: "M51.01 46.17l.308 58.82c7.729-15.479 29.06-13.002 29.06-13.002 7.11.928 8.038-3.406 8.038-3.406v-44.58c2.164-3.095 4.637 0 4.637 0l-.309 52.939-39.88 15.479H6.183c-2.473-1.548-.31-3.715-.31-3.715h32.77c5.256 0 4.947-5.263 4.947-5.263v-52.32H6.8c-6.183 0-6.183 4.954-6.183 4.954v54.796c0 5.882 5.874 5.882 5.874 5.882h46.063l42.044-14.55c2.473-1.858 2.782-5.263 2.782-5.263V43.693c-2.164-5.573-6.801-6.501-9.274-6.501-4.947-3.715-9.584-5.263-13.912-5.263-13.293 0-23.186 14.24-23.186 14.24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rc_loading_icon_svg__paint0_linear",
    x1: 46.551,
    y1: 116.597,
    x2: 199.017,
    y2: 116.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6699C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#66A3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#66C1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rc_loading_icon_svg__paint1_linear",
    x1: 0.733,
    y1: 116.944,
    x2: 97.407,
    y2: 116.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6699C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#66A3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#66C1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rc_loading_icon_svg__cloud-clip"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#rc_loading_icon_svg__cloud"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rc_loading_icon_svg__book-clip"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#rc_loading_icon_svg__book"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rc_loading_icon_svg__f1",
    x: 0,
    y: 0,
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offOut",
    "in": "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "matrixOut",
    "in": "offOut",
    values: "2 0 0 0 0 0 2 0 0 0 0 0 2 0 0 0 0 0 2 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blurOut",
    "in": "matrixOut",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "blurOut"
  })))));
}
export default __webpack_public_path__ + "d67689de7ea28f0ef02108aaf76d78d4.svg";
export { SvgRcLoadingIcon as ReactComponent };